var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topman"},[_vm._v(" 地址分布 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }